/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Import_DashboardInputs */



/**
* | output |
* | --- |
* | "Shot Description Import Dashboard" |
*
* @param {Scene_Description_Import_DashboardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_import_dashboard = /** @type {((inputs?: Scene_Description_Import_DashboardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Import_DashboardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du plan Importer le tableau de bord")
	if (locale === "de") return /** @type {LocalizedString} */ ("Shot-Beschreibung Import-Dashboard")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione dello scatto Importa dashboard")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Панель управления импортом описания кадра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Panel de importación de descripción de tomas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头描述导入仪表板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットの説明 ダッシュボードのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट विवरण आयात डैशबोर्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição da cena Importar painel de controle")
	return /** @type {LocalizedString} */ ("Shot Description Import Dashboard")
});